<div class="flex flex-col">
  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                  'bg-gray-600': sharedService.userTheme === 'dark',
                  'bg-indigo-50': sharedService.userTheme === 'light'}">
      <div class="flex flex-row items-center padding10">
        <div class="flex flex-row w-full">
          <div>
            <span *ngIf="list.length == 0 && editMode == 'list'">HST</span>
          </div>
          <div>
            <span *ngIf="list.length > 0 && editMode == 'list'">HST: {{list.length}} </span>
          </div>
          <div>
            <span *ngIf="editMode == 'add' ">Adding HST</span>
          </div>
        </div>

        <div class="flex flex-row">
          <button mat-icon-button *ngIf="editMode == 'list' && !labService.readonly && !isHstLab" matTooltip="Add New HST" (click)="addHst()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">add</mat-icon>
          </button>
          <button mat-icon-button *ngIf="editMode !== 'list' && !labService.readonly && inputLab != null" matTooltip="Save" (click)="save()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">save</mat-icon>
          </button>
          <button mat-icon-button *ngIf="editMode == 'edit' && !labService.readonly" matTooltip="Delete" (click)="delete()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''" class="text-red-500">delete</mat-icon>
          </button>
          <button mat-icon-button *ngIf="editMode !== 'list'" matTooltip="Cancel" (click)="cancel()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">cancel</mat-icon>
          </button>
        </div>
      </div>
    </mat-card>
  </div>

  <div class="flex flex-row" *ngIf="editMode == 'list'">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
          'bg-gray-700': sharedService.userTheme === 'dark',
          'bg-indigo-50': sharedService.userTheme === 'light'}">
      <mat-card-content>

        <div class="flex flex-col" *ngIf="list.length > 0 ">
          <div class="flex flex-row">
            <mat-form-field class="flex-1 min-w-[30%] sm:min-w-full">
              <input matInput id="listFilter" (keyup)="filterTable($event)" placeholder="Filter"
                value="{{listFilter}}" />

              <button *ngIf="listFilter" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <div style="overflow-x:auto">
            <div class="flex flex-row">
              <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort"
                class="mat-elevation-z8 w-full" matSortActive="labName" matSortDirection="desc">
                <ng-container matColumnDef="labName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Lab Name</th>
                  <td mat-cell *matCellDef="let change">{{change.labName}}</td>
                </ng-container>
                <ng-container matColumnDef="stateNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>State Number</th>
                  <td mat-cell *matCellDef="let change">{{change.stateNumber}}</td>
                </ng-container>
                <ng-container matColumnDef="cliaNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>CLIA Number</th>
                  <td mat-cell *matCellDef="let change">{{change.cliaNumber}}</td>
                </ng-container>
                <ng-container matColumnDef="comments">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Comments</th>
                  <td mat-cell *matCellDef="let change">{{change.comments}}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="rowclick(row)"></tr>
              </table>
            </div>
          </div>
          <mat-paginator [pageSizeOptions]="getPageSizeOptions()" #TablePaginator="matPaginator" 
            showFirstLastButtons>
          </mat-paginator>
        </div>

      </mat-card-content>

    </mat-card>
  </div>

  <div class="flex flex-row" *ngIf="editMode == 'add'">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
          'bg-gray-700': sharedService.userTheme === 'dark',
          'bg-indigo-50': sharedService.userTheme === 'light'}">
      <div class="flex flex-row flex-wrap w-full sm:flex-col">
        <mat-card-content class="w-full gap-4">
          <div class="flex flex-col mt-4">

            <mat-form-field>
              <mat-label>Ownership Type</mat-label>
              <mat-select [(ngModel)]=inputLab>
                <mat-option *ngFor="let item of hstList" [value]="item">{{item.labName}} ({{item.stateNumber}})
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Comments</mat-label>
              <textarea matInput cdkTextareaAutosize [(ngModel)]='inputComments'></textarea>
            </mat-form-field>
          </div>
        </mat-card-content>
      </div>
    </mat-card>
  </div>

  <div class="flex flex-row" *ngIf="editMode == 'edit'">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                'bg-gray-700': sharedService.userTheme === 'dark',
                'bg-indigo-50': sharedService.userTheme === 'light'}">
      <div class="flex flex-row flex-wrap w-full sm:flex-col">
        <mat-card-content class="w-full gap-4">
          <div class="flex flex-col mt-4">
            <div class="flex flex-col">
              <mat-form-field *ngIf="editMode == 'edit'">
                <mat-label>HST Lab Name</mat-label>
                <input matInput [(ngModel)]="hstLabName" [readonly]="true">
              </mat-form-field>
              <mat-form-field>
                <mat-label>State Numner</mat-label>
                <input matInput [(ngModel)]="stateNumber" [readonly]="true">
              </mat-form-field>
              <mat-form-field>
                <mat-label>CLIA Number</mat-label>
                <input matInput [(ngModel)]="cliaNumber" [readonly]="true">
              </mat-form-field>

              <mat-form-field>
                <mat-label>Comments</mat-label>
                <textarea matInput cdkTextareaAutosize [(ngModel)]='inputComments'></textarea>
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </div>
    </mat-card>
  </div>

</div>

